import Vue from 'vue';
import Router from 'vue-router';

import { TOKEN } from '@Consts/strings';

import Login from '@Views/login';
import FormularioLink from '@Views/link-formulario/formulario';

import UsuarioPresenter from '@Presenter/usuario-presenter';
import store from '../store';
import functions from './functions';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Notas',
      component: () => import(/* webpackChunkName: "n-1" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        roles: [
          'paciente'
        ]
      },
      children: [
        {
          path: '/paciente/evolucoes',
          name: 'Notas',
          component: () => import(/* webpackChunkName: "n-2" */ '@Views/dashboard/conteudo/principal/pacientes/notas')
        },
        {
          path: '/paciente/exames',
          name: 'ExamesPaciente_Familia',
          component: () => import(/* webpackChunkName: "n-3" */ '@Views/dashboard/conteudo/principal/exames')
        },
        {
          path: '/paciente/medica',
          name: 'Prescricoes_Familia',
          component: () => import(/* webpackChunkName: "n-4" */ '@Views/dashboard/conteudo/prescricoes/medica')
        },
        {
          path: '/paciente/medica/:id',
          name: 'Prescricao_Familia',
          component: () => import(/* webpackChunkName: "n-5" */ '@Views/dashboard/conteudo/prescricoes/medica')
        },
        {
          path: '/paciente/enfermagem',
          name: 'PrescricoesEnfermagem_Familia',
          component: () => import(/* webpackChunkName: "n-6" */ '@Views/dashboard/conteudo/prescricoes/enfermagem')
        },
        {
          path: '/paciente/enfermagem/:id',
          name: 'PrescricaoEnfermagem_Familia',
          component: () => import(/* webpackChunkName: "n-7" */ '@Views/dashboard/conteudo/prescricoes/enfermagem/prescricao')
        },
        {
          path: '/paciente/dieta',
          name: 'PrescricoesDieta_Familia',
          component: () => import(/* webpackChunkName: "n-8" */ '@Views/dashboard/conteudo/prescricoes/dietas')
        },
        {
          path: '/paciente/dieta/:id',
          name: 'PrescricaoDieta_Familia',
          component: () => import(/* webpackChunkName: "n-9" */ '@Views/dashboard/conteudo/prescricoes/dietas/prescricao')
        },
        {
          path: 'paciente/avaliacao-profissional',
          name: 'AvaliacaoProfissional_Familia',
          component: () => import(/* webpackChunkName: "n-10" */ '@Views/dashboard/conteudo/principal/pacientes/avaliacao-profissional')
        },
        {
          path: 'paciente/acompanhamento-familiar',
          name: 'AcompanhamentoFamilia_Familia',
          component: () => import(/* webpackChunkName: "n-11" */ '@Views/dashboard/conteudo/principal/pacientes/acompanhamento-familia')
        }
      ]
    },
    {
      path: '/profissional-web',
      name: 'ProfissionalWeb',
      component: () => import(/* webpackChunkName: "n-12" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        roles: [
          'funcionario'
        ]
      },
      children: [
        {
          path: 'pacientes',
          name: 'ProfissionalPacientes',
          component: () => import(/* webpackChunkName: "n-13" */ '@Views/dashboard/conteudo/principal/profissionais/pacientes')
        },
        {
          path: 'pacientes/:id/evolucoes',
          name: 'ProfissionalPacientesEvolucoes',
          component: () => import(/* webpackChunkName: "n-14" */ '@Views/dashboard/conteudo/principal/pacientes/evolucoes')
        },
        {
          path: 'pacientes/:id/evolucoes',
          name: 'ProfissionalPacientesEvolucoes',
          component: () => import(/* webpackChunkName: "n-15" */ '@Views/dashboard/conteudo/principal/pacientes/evolucoes')
        },
        {
          path: 'pacientes/:id/visitas',
          name: 'ProfissionalPacientesVisitas',
          component: () => import(/* webpackChunkName: "n-16" */ '@Views/dashboard/conteudo/principal/pacientes/visitas')
        },
        {
          path: 'pacientes/exames',
          name: 'ExamesPaciente_Funcionario',
          component: () => import(/* webpackChunkName: "n-17" */ '@Views/dashboard/conteudo/principal/exames')
        },
        {
          path: 'pacientes/medica',
          name: 'Prescricoes_Funcionario',
          component: () => import(/* webpackChunkName: "n-18" */ '@Views/dashboard/conteudo/prescricoes/medica')
        },
        {
          path: 'pacientes/medica/:id',
          name: 'Prescricao_Funcionario',
          component: () => import(/* webpackChunkName: "n-19" */ '@Views/dashboard/conteudo/prescricoes/medica/prescricao')
        },
        {
          path: 'pacientes/enfermagem',
          name: 'PrescricoesEnfermagem_Funcionario',
          component: () => import(/* webpackChunkName: "n-20" */ '@Views/dashboard/conteudo/prescricoes/enfermagem')
        },
        {
          path: 'pacientes/enfermagem/:id',
          name: 'PrescricaoEnfermagem_Funcionario',
          component: () => import(/* webpackChunkName: "n-21" */ '@Views/dashboard/conteudo/prescricoes/enfermagem/prescricao')
        },
        {
          path: 'pacientes/dieta',
          name: 'PrescricoesDieta_Funcionario',
          component: () => import(/* webpackChunkName: "n-22" */ '@Views/dashboard/conteudo/prescricoes/dietas')
        },
        {
          path: 'pacientes/dieta/:id',
          name: 'PrescricaoDieta_Funcionario',
          component: () => import(/* webpackChunkName: "n-23" */ '@Views/dashboard/conteudo/prescricoes/dietas/prescricao')
        }
      ]
    },
    {
      path: '/',
      name: 'Dashboard',
      component: () => import(/* webpackChunkName: "n-24" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Cadastros',
        roles: [
          'personalizada',
          'administrador',
          'gerente',
          'assistente',
          'comercial'
        ]
      },
      children: [
        {
          path: 'modelos-documento',
          name: 'ModelosDocumento',
          component: () => import(/* webpackChunkName: "n-25" */'@Views/dashboard/conteudo/empresa/modelos-documento')
        }
      ]
    },
    {
      path: '/',
      name: 'Dashboard',
      component: () => import(/* webpackChunkName: "n-26" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Principal',
        roles: [
          'personalizada',
          'administrador',
          'gerente',
          'Comercial'
        ]
      },
      children: [
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: 'pacientes/:id/avaliacao-profissional',
          name: 'AvaliacaoProfissional_Pacientes',
          component: () => import(/* webpackChunkName: "n-27" */'@Views/dashboard/conteudo/principal/pacientes/avaliacao-profissional')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: 'pacientes/:id/acompanhamento-familiar',
          name: 'AcompanhamentoFamiliar_Pacientes',
          component: () => import(/* webpackChunkName: "n-28" */ '@Views/dashboard/conteudo/principal/pacientes/acompanhamento-familia')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: 'pacientes/:id/avaliacao-profissional-relatorio',
          name: 'AvaliacaoProfissionalRelatorio_Pacientes',
          component: () => import(/* webpackChunkName: "n-29" */'@Views/dashboard/conteudo/principal/pacientes/avaliacao-profissional/avaliacao_profissional_relatorio')
        },
        {
          meta: {
            child_names: ['Profissionais'],
            child_menus: ['Principal']
          },
          path: 'profissionais/:id/avaliacao-profissional',
          name: 'AvaliacaoProfissional',
          component: () => import(/* webpackChunkName: "n-30" */'@Views/dashboard/conteudo/principal/profissionais/avaliacao-profissional')
        },
        {
          meta: {
            child_names: ['Profissionais'],
            child_menus: ['Principal']
          },
          path: 'profissionais/:id/avaliacao-profissional-relatorio',
          name: 'AvaliacaoProfissionalRelatorio',
          component: () => import(/* webpackChunkName: "n-31" */'@Views/dashboard/conteudo/principal/profissionais/avaliacao-profissional/avaliacao_profissional_relatorio')
        },
        {
          meta: {
            child_names: ['Profissionais'],
            child_menus: ['Principal']
          },
          path: '/profissionais/:id/custos-servicos',
          name: 'CustosServicos',
          component: () => import(/* webpackChunkName: "n-32" */ '@Views/dashboard/conteudo/principal/profissionais/servicos')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: '/pacientes/:id/precos',
          name: 'PrecosPacientes',
          component: () => import(/* webpackChunkName: "n-3" */ '@Views/dashboard/conteudo/principal/pacientes/precos')
        }
      ]
    },
    {
      path: '/',
      name: 'Dashboard',
      component: () => import(/* webpackChunkName: "n-33" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Instituições',
        roles: [
          'superAdministrador'
        ]
      },
      children: [
        {
          path: '/instituicoes',
          name: 'Instituições',
          component: () => import(/* webpackChunkName: "n-34" */ '@Views/dashboard/conteudo/configuracoes/instituicoes')
        },
        {
          path: '/relatorios-gerais',
          name: 'Relatórios Gerais',
          component: () => import(/* webpackChunkName: "n-34" */ '@Views/dashboard/conteudo/configuracoes/relatorios')
        }
      ]
    },
    {
      path: '/',
      name: 'Dashboard',
      component: () => import(/* webpackChunkName: "n-33" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Principal',
        roles: [
          'personalizada',
          'administrador',
          'gerente',
          'assistente',
          'secretario',
          'comercial'
        ]
      },
      children: [
        {
          path: '/inicio',
          name: 'Inicio',
          component: () => import(/* webpackChunkName: "n-34" */ '@Views/dashboard/conteudo/principal/inicio')
        },
        {
          meta: {
            child_names: ['Avisos'],
            child_menus: ['Principal']
          },
          path: '/avisos',
          name: 'Avisos',
          component: () => import(/* webpackChunkName: "n-35" */ '@Views/dashboard/conteudo/principal/avisos'),
          visible: false
        },
        {
          meta: {
            child_names: ['Profissionais'],
            child_menus: ['Principal']
          },
          path: '/profissionais',
          name: 'Profissionais',
          component: () => import(/* webpackChunkName: "n-36" */ '@Views/dashboard/conteudo/principal/profissionais')
        },
        {
          meta: {
            child_names: ['Profissionais'],
            child_menus: ['Principal']
          },
          path: '/profissionais/:id/mapa',
          name: 'MapaProfissional',
          component: () => import(/* webpackChunkName: "n-37" */ '@Views/dashboard/conteudo/principal/mapa-profissional-paciente')
        },
        {
          meta: {
            child_names: ['Profissionais', 'Pacientes'],
            child_menus: ['Principal', 'Principal']
          },
          path: '/profissionais/:id/exames',
          name: 'ExamesProfissional',
          component: () => import(/* webpackChunkName: "n-38" */ '@Views/dashboard/conteudo/principal/exames')
        },
        {
          meta: {
            child_names: ['Profissionais'],
            child_menus: ['Principal']
          },
          path: '/profissionais/:id/folha-pagamento',
          name: 'FolhasPagamentoProfissional',
          component: () => import(/* webpackChunkName: "n-39" */ '@Views/dashboard/conteudo/gestao-pessoas/folhas-pagamento/')
        },
        {
          meta: {
            child_names: ['Profissionais'],
            child_menus: ['Principal']
          },
          path: '/profissionais/:id/agenda',
          name: 'ProfissionalAgenda',
          component: () => import(/* webpackChunkName: "n-40" */'@Views/dashboard/conteudo/principal/agenda')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: '/pacientes',
          name: 'Pacientes',
          component: () => import(/* webpackChunkName: "n-41" */ '@Views/dashboard/conteudo/principal/pacientes')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: '/pacientes/:id/evolucoes',
          name: 'Evolucoes',
          component: () => import(/* webpackChunkName: "n-42" */ '@Views/dashboard/conteudo/principal/pacientes/evolucoes')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: '/pacientes/:id/mapa',
          name: 'MapaPaciente',
          component: () => import(/* webpackChunkName: "n-43" */ '@Views/dashboard/conteudo/principal/mapa-profissional-paciente')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: '/pacientes/:id/exames',
          name: 'ExamesPaciente',
          component: () => import(/* webpackChunkName: "n-44" */ '@Views/dashboard/conteudo/principal/exames')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: '/pacientes/:id/visitas',
          name: 'Visitas',
          component: () => import(/* webpackChunkName: "n-45" */ '@Views/dashboard/conteudo/principal/pacientes/visitas')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: '/pacientes/:id/agenda',
          name: 'PacienteAgenda',
          component: () => import(/* webpackChunkName: "n-46" */'@Views/dashboard/conteudo/principal/agenda')
        },
        {
          meta: {
            child_names: ['Indicadores de Saúde'],
            child_menus: ['Principal']
          },
          path: '/indicadores-saude',
          name: 'IndicadoresSaude',
          component: () => import(/* webpackChunkName: "n-134" */ '@Views/dashboard/conteudo/principal/indicadores-saude')
        },
        {
          meta: {
            child_names: ['Indicadores de Saúde'],
            child_menus: ['Principal']
          },
          path: '/indicadores-saude/relatorios/:modelo_id?',
          name: 'RelatoriosIndicadores',
          component: () => import(/* webpackChunkName: "n-135" */ '@Views/dashboard/conteudo/principal/indicadores-saude/relatorios')
        },
        {
          meta: {
            child_names: ['Status de Pacientes'],
            child_menus: ['Principal']
          },
          path: '/status-pacientes',
          name: 'StatusPacientes',
          component: () => import(/* webpackChunkName: "n-47" */ '@Views/dashboard/conteudo/principal/status-pacientes')
        },
        {
          meta: {
            child_names: ['Sinais Vitais'],
            child_menus: ['Principal']
          },
          path: '/sinais-vitais',
          name: 'SinaisVitais',
          component: () => import(/* webpackChunkName: "n-48" */ '@Views/dashboard/conteudo/principal/sinais-vitais')
        },
        {
          meta: {
            child_names: ['Visitas à empresa'],
            child_menus: ['Principal']
          },
          path: '/visitas-empresa',
          name: 'VisitasEmpresa',
          component: () => import(/* webpackChunkName: "n-49" */ '@Views/dashboard/conteudo/principal/visitas-empresa')
        },
        {
          meta: {
            child_names: ['Profissionais'],
            child_menus: ['Principal']
          },
          path: '/avaliacao-antropometrica',
          name: 'AvaliacaoAntropometrica',
          component: () => import(/* webpackChunkName: "n-50" */ '@Views/dashboard/conteudo/principal/avaliacao-antropometrica')
        },
        {
          meta: {
            child_names: ['Pacientes'],
            child_menus: ['Principal']
          },
          path: '/pacientes/:id/pacotes',
          name: 'PacotesPaciente',
          component: () => import(/* webpackChunkName: "n-51" */ '@Views/dashboard/conteudo/principal/pacientes/pacotes')
        }
      ]
    },
    {
      path: '/prescricoes',
      name: 'Prescricoes',
      component: () => import(/* webpackChunkName: "n-52" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        roles: [
          'personalizada',
          'administrador',
          'gerente',
          'assistente',
          'secretario',
          'funcionario',
          'comercial'
        ],
        name_permission: 'Prescrições'
      },
      children: [
        {
          meta: {
            child_names: ['Médica'],
            child_menus: ['Prescrições']
          },
          path: 'medica/:paciente_id',
          name: 'Prescricoes',
          component: () => import(/* webpackChunkName: "n-53" */ '@Views/dashboard/conteudo/prescricoes/medica')
        },
        {
          meta: {
            child_names: ['Médica'],
            child_menus: ['Prescrições']
          },
          path: 'medica/:id',
          name: 'Prescricao',
          component: () => import(/* webpackChunkName: "n-54" */ '@Views/dashboard/conteudo/prescricoes/medica/prescricao')
        },
        {
          meta: {
            child_names: ['Médica'],
            child_menus: ['Prescrições']
          },
          path: 'medica',
          name: 'Prescricoes',
          component: () => import(/* webpackChunkName: "n-55" */ '@Views/dashboard/conteudo/prescricoes/medica')
        },
        {
          meta: {
            child_names: ['Enfermagem'],
            child_menus: ['Prescrições']
          },
          path: 'enfermagem/:paciente_id',
          name: 'PrescricoesEnfermagem',
          component: () => import(/* webpackChunkName: "n-56" */ '@Views/dashboard/conteudo/prescricoes/enfermagem')
        },
        {
          meta: {
            child_names: ['Enfermagem'],
            child_menus: ['Prescrições']
          },
          path: 'enfermagem/:id',
          name: 'PrescricaoEnfermagem',
          component: () => import(/* webpackChunkName: "n-57" */ '@Views/dashboard/conteudo/prescricoes/enfermagem/prescricao')
        },
        {
          meta: {
            child_names: ['Enfermagem'],
            child_menus: ['Prescrições']
          },
          path: 'enfermagem',
          name: 'PrescricoesEnfermagem',
          component: () => import(/* webpackChunkName: "n-58" */ '@Views/dashboard/conteudo/prescricoes/enfermagem')
        },
        {
          meta: {
            child_names: ['Dieta'],
            child_menus: ['Prescrições']
          },
          path: 'dieta/:paciente_id',
          name: 'PrescricoesDieta',
          component: () => import(/* webpackChunkName: "n-59" */ '@Views/dashboard/conteudo/prescricoes/dietas')
        },
        {
          meta: {
            child_names: ['Dieta'],
            child_menus: ['Prescrições']
          },
          path: 'dieta/:id',
          name: 'PrescricaoDieta',
          component: () => import(/* webpackChunkName: "n-60" */ '@Views/dashboard/conteudo/prescricoes/dietas/prescricao')
        },
        {
          meta: {
            child_names: ['Dieta'],
            child_menus: ['Prescrições']
          },
          path: 'dieta',
          name: 'PrescricoesDieta',
          component: () => import(/* webpackChunkName: "n-61" */ '@Views/dashboard/conteudo/prescricoes/dietas')
        }
      ]

    },
    {
      path: '/farmacia',
      component: () => import(/* webpackChunkName: "n-62" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        roles: [
          'personalizada',
          'administrador',
          'gerente',
          'assistente',
          'secretario',
          'comercial'
        ],
        name_permission: 'Farmácia'
      },
      children: [
        {
          meta: {
            child_names: ['Geral'],
            child_menus: ['Farmácia']
          },
          path: 'geral',
          name: 'Farmacia',
          component: () => import(/* webpackChunkName: "n-63" */ '@Views/dashboard/conteudo/farmacia')
        },
        {
          meta: {
            child_names: ['Dispensação programada'],
            child_menus: ['Farmácia']
          },
          path: 'dispensacao-programada',
          name: 'FarmaciaDispensacaoProgramada',
          component: () => import(/* webpackChunkName: "n-64" */ '@Views/dashboard/conteudo/farmacia/dispensacao-programada')
        },
        {
          meta: {
            child_names: ['Geral', 'Dispensação programada'],
            child_menus: ['Farmácia', 'Farmácia']
          },
          path: ':id/dispensacao',
          name: 'Dispensacao',
          component: () => import(/* webpackChunkName: "n-65" */ '@Views/dashboard/conteudo/farmacia/dispensacao')
        },
        {
          meta: {
            child_names: ['Geral', 'Dispensação programada'],
            child_menus: ['Farmácia', 'Farmácia']
          },
          path: ':id/estorno',
          name: 'Estorno',
          component: () => import(/* webpackChunkName: "n-66" */ '@Views/dashboard/conteudo/farmacia/estorno')
        },
        {
          meta: {
            child_names: ['Geral', 'Dispensação programada'],
            child_menus: ['Farmácia', 'Farmácia']
          },
          path: 'venda/dispensacao/:id',
          name: 'Venda Dispensacao',
          component: () => import(/* webpackChunkName: "n-67" */ '@Views/dashboard/conteudo/farmacia/venda-dispensacao')
        }
      ]

    },
    {
      path: '/estoque',
      name: 'Estoque',
      component: () => import(/* webpackChunkName: "n-68" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Estoque',
        roles: [
          'personalizada',
          'administrador',
          'gerente',
          'assistente',
          'secretario',
          'comercial'
        ]
      },
      children: [
        {
          meta: {
            child_names: ['Medicamentos'],
            child_menus: ['Estoque']
          },
          path: 'medicamentos',
          name: 'MedicamentosEstoque',
          component: () => import(/* webpackChunkName: "n-69" */ '@Views/dashboard/conteudo/estoque/medicamentos')
        },
        {
          meta: {
            child_names: ['Materiais'],
            child_menus: ['Estoque']
          },
          path: 'materiais',
          name: 'MateriaisEstoque',
          component: () => import(/* webpackChunkName: "n-70" */ '@Views/dashboard/conteudo/estoque/materiais')
        },
        {
          meta: {
            child_names: ['Equipamentos'],
            child_menus: ['Estoque']
          },
          path: 'equipamentos',
          name: 'EquipamentosEstoque',
          component: () => import(/* webpackChunkName: "n-71" */ '@Views/dashboard/conteudo/estoque/equipamentos')
        },
        {
          meta: {
            child_names: ['Dietas'],
            child_menus: ['Estoque']
          },
          path: 'dietas',
          name: 'DietasEstoque',
          component: () => import(/* webpackChunkName: "n-72" */ '@Views/dashboard/conteudo/estoque/dietas')
        }
      ]
    },
    {
      path: '/empresa',
      name: 'empresa',
      component: () => import(/* webpackChunkName: "n-73" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Cadastros',
        roles: [
          'personalizada',
          'administrador',
          'gerente'
        ]
      },
      children: [
        {
          meta: {
            child_names: ['Especialidades'],
            child_menus: ['Cadastros']
          },
          path: 'especialidades',
          name: 'Especialidades',
          component: () => import(/* webpackChunkName: "n-74" */ '@Views/dashboard/conteudo/empresa/especialidades')
        },
        {
          meta: {
            child_names: ['Convênios'],
            child_menus: ['Cadastros']
          },
          path: 'convenios',
          name: 'Convenios',
          component: () => import(/* webpackChunkName: "n-75" */ '@Views/dashboard/conteudo/empresa/convenios')
        },
        {
          meta: {
            child_names: ['Medicamentos'],
            child_menus: ['Cadastros']
          },
          path: 'medicamentos',
          name: 'Medicamentos',
          component: () => import(/* webpackChunkName: "n-76" */ '@Views/dashboard/conteudo/empresa/medicamentos')
        },
        {
          meta: {
            child_names: ['Serviços'],
            child_menus: ['Cadastros']
          },
          path: 'servicos',
          name: 'Servicos',
          component: () => import(/* webpackChunkName: "n-77" */ '@Views/dashboard/conteudo/empresa/servicos')
        },
        {
          meta: {
            child_names: ['Materiais'],
            child_menus: ['Cadastros']
          },
          path: 'materiais',
          name: 'Materiais',
          component: () => import(/* webpackChunkName: "n-78" */ '@Views/dashboard/conteudo/empresa/materiais')
        },
        {
          meta: {
            child_names: ['Dietas'],
            child_menus: ['Cadastros']
          },
          path: 'dietas',
          name: 'Dietas',
          component: () => import(/* webpackChunkName: "n-79" */ '@Views/dashboard/conteudo/empresa/dieta')
        },
        {
          meta: {
            child_names: ['Equipamentos'],
            child_menus: ['Cadastros']
          },
          path: 'equipamentos',
          name: 'Equipamentos',
          component: () => import(/* webpackChunkName: "n-80" */ '@Views/dashboard/conteudo/empresa/equipamentos')
        },
        {
          meta: {
            child_names: ['Kits'],
            child_menus: ['Cadastros']
          },
          path: 'kits',
          name: 'Kits',
          component: () => import(/* webpackChunkName: "n-81" */ '@Views/dashboard/conteudo/empresa/kits')
        },
        {
          meta: {
            child_names: ['Escalas'],
            child_menus: ['Cadastros']
          },
          path: 'escalas',
          name: 'Escalas',
          component: () => import(/* webpackChunkName: "n-82" */ '@Views/dashboard/conteudo/empresa/escalas')
        },
        {
          meta: {
            child_names: ['Fornecedores e Clientes'],
            child_menus: ['Cadastros']
          },
          path: 'fornecedores',
          name: 'Fornecedores',
          component: () => import(/* webpackChunkName: "n-83" */ '@Views/dashboard/conteudo/empresa/fornecedores/')
        },
        {
          meta: {
            child_names: ['Aniversariantes'],
            child_menus: ['Cadastros']
          },
          path: 'aniversariantes',
          name: 'Aniversariantes',
          component: () => import(/* webpackChunkName: "n-84" */ '@Views/dashboard/conteudo/empresa/aniversariantes')
        },
        {
          meta: {
            child_names: ['Modelos de evolução'],
            child_menus: ['Cadastros']
          },
          path: 'modelos-evolucao',
          name: 'ModelosEvolucao',
          component: () => import(/* webpackChunkName: "n-85" */ '@Views/dashboard/conteudo/empresa/modelos-evolucao')
        },
        {
          meta: {
            child_names: ['Modelos de formulários'],
            child_menus: ['Cadastros']
          },
          path: 'modelos-formularios',
          name: 'ModelosFormularios',
          component: () => import(/* webpackChunkName: "n-85" */ '@Views/dashboard/conteudo/empresa/modelos-formularios')
        },
        {
          meta: {
            child_names: ['Modelos de formulários'],
            child_menus: ['Cadastros']
          },
          path: 'modelos-formularios/:modelo_id/submissoes/:tipo?',
          name: 'SubmissoesFormulario',
          component: () => import(/* webpackChunkName: "n-85" */ '@Views/dashboard/conteudo/empresa/modelos-formularios/submissoes')
        },
        {
          meta: {
            child_names: ['Acompanhamento familiar'],
            child_menus: ['Cadastros']
          },
          path: 'acompanhamento-familiar',
          name: 'AcompanhamentoFamiliar',
          component: () => import(/* webpackChunkName: "n-86" */ '@Views/dashboard/conteudo/empresa/acompanhamento-familiar')
        },
        {
          meta: {
            child_names: ['Avaliação profissional'],
            child_menus: ['Cadastros']
          },
          path: 'avaliacao-profissional',
          name: 'AvaliacaoProfissionalEmpresa',
          component: () => import(/* webpackChunkName: "n-87" */ '@Views/dashboard/conteudo/empresa/avaliacao-profissional')
        },
        {
          meta: {
            child_names: ['Avaliação profissional'],
            child_menus: ['Cadastros']
          },
          path: 'avaliacao-profissionais-relatorio',
          name: 'AvaliacaoProfissionaisRelatorioEmpresa',
          component: () => import(/* webpackChunkName: "n-88" */ '@Views/dashboard/conteudo/empresa/avaliacao-profissional/avaliacao_profissionais_relatorio')
        },
        {
          meta: {
            child_names: ['Folha de pagamento'],
            child_menus: ['Cadastros']
          },
          path: 'folha-pagamento',
          name: 'FolhaPagamentoEmpresa',
          component: () => import(/* webpackChunkName: "n-89" */ '@Views/dashboard/conteudo/empresa/folha-pagamento')
        },
        {
          meta: {
            child_names: ['Relatórios'],
            child_menus: ['Cadastros']
          },
          path: 'relatorios',
          name: 'Relatorios',
          component: () => import(/* webpackChunkName: "n-90" */ '@Views/dashboard/conteudo/empresa/relatorios')
        },
        {
          meta: {
            child_names: ['Assinar Documento'],
            child_menus: ['Cadastros']
          },
          path: 'assinar-documento',
          name: 'AssinarDocumento',
          component: () => import(/* webpackChunkName: "n-91" */ '@Views/dashboard/conteudo/empresa/assinar_documento')
        },
        {
          meta: {
            child_names: ['Pacotes'],
            child_menus: ['Cadastros']
          },
          path: 'pacotes',
          name: 'Pacotes',
          component: () => import(/* webpackChunkName: "n-92" */ '@Views/dashboard/conteudo/empresa/pacotes')
        }
      ]
    },
    {
      path: '/financeiro',
      name: 'financeiro',
      component: () => import(/* webpackChunkName: "n-93" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Comercial',
        roles: [
          'personalizada',
          'administrador',
          'gerente',
          'comercial'
        ]
      },
      children: [
        {
          meta: {
            child_names: ['Compras'],
            child_menus: ['Comercial']
          },
          path: 'compras',
          name: 'Compras',
          component: () => import(/* webpackChunkName: "n-94" */ '@Views/dashboard/conteudo/financeiro/compras')
        },
        {
          meta: {
            child_names: ['Compras'],
            child_menus: ['Comercial']
          },
          path: 'compras/:id',
          name: 'Compra',
          component: () => import(/* webpackChunkName: "n-95" */ '@Views/dashboard/conteudo/financeiro/compras/compra')
        },
        {
          meta: {
            child_names: ['Despesas'],
            child_menus: ['Comercial']
          },
          path: 'despesas',
          name: 'Despesas',
          component: () => import(/* webpackChunkName: "n-96" */ '@Views/dashboard/conteudo/financeiro/despesas')
        },
        {
          meta: {
            child_names: ['Orçamentos'],
            child_menus: ['Comercial']
          },
          path: 'orcamentos',
          name: 'Orcamentos',
          component: () => import(/* webpackChunkName: "n-97" */ '@Views/dashboard/conteudo/financeiro/orcamentos')
        },
        {
          meta: {
            child_names: ['Orçamentos'],
            child_menus: ['Comercial']
          },
          path: 'orcamentos/:id',
          name: 'Orcamento',
          component: () => import(/* webpackChunkName: "n-98" */ '@Views/dashboard/conteudo/financeiro/orcamentos/orcamento')
        },
        {
          meta: {
            child_names: ['Vendas'],
            child_menus: ['Comercial']
          },
          path: 'vendas',
          name: 'Vendas',
          component: () => import(/* webpackChunkName: "n-99" */ '@Views/dashboard/conteudo/financeiro/vendas')
        },
        {
          meta: {
            child_names: ['Vendas'],
            child_menus: ['Comercial']
          },
          path: 'vendas/:id',
          name: 'Venda',
          component: () => import(/* webpackChunkName: "n-100" */ '@Views/dashboard/conteudo/financeiro/vendas/venda')
        },
        {
          meta: {
            child_names: ['Faturamento XML'],
            child_menus: ['Comercial']
          },
          path: 'lote-guias',
          name: 'LoteGuias',
          component: () => import(/* webpackChunkName: "n-101" */ '@Views/dashboard/conteudo/financeiro/xml/lotes')
        },
        {
          meta: {
            child_names: ['Faturamento XML'],
            child_menus: ['Comercial']
          },
          path: 'lote-guias/:id/guias',
          name: 'Guias',
          component: () => import(/* webpackChunkName: "n-102" */ '@Views/dashboard/conteudo/financeiro/xml/guias')
        },
        {
          meta: {
            child_names: ['Faturamento XML'],
            child_menus: ['Comercial']
          },
          path: 'importar_xml',
          name: 'ImportarXML',
          component: () => import(/* webpackChunkName: "n-103" */ '@Views/dashboard/conteudo/financeiro/importarXML/')
        }
      ]
    },
    {
      path: '/financeiro',
      name: 'financeiro',
      component: () => import(/* webpackChunkName: "n-104" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Financeiro',
        roles: [
          'personalizada',
          'administrador',
          'gerente'
        ]
      },
      children: [
        {
          meta: {
            child_names: ['Contas a Pagar'],
            child_menus: ['Financeiro']
          },
          path: 'contas-pagar',
          name: 'ContasPagar',
          component: () => import(/* webpackChunkName: "n-105" */ '@Views/dashboard/conteudo/financeiro/contasPagar')
        },
        {
          meta: {
            child_names: ['Contas a Receber'],
            child_menus: ['Financeiro']
          },
          path: 'contas-receber',
          name: 'ContasReceber',
          component: () => import(/* webpackChunkName: "n-106" */ '@Views/dashboard/conteudo/financeiro/contasReceber')
        },
        {
          meta: {
            child_names: ['Contas'],
            child_menus: ['Financeiro']
          },
          path: 'contas',
          name: 'Contas',
          component: () => import(/* webpackChunkName: "n-107" */ '@Views/dashboard/conteudo/financeiro/contas')
        },
        {
          meta: {
            child_names: ['Contas'],
            child_menus: ['Financeiro']
          },
          path: 'contas/:id',
          name: 'Conta',
          component: () => import(/* webpackChunkName: "n-108" */ '@Views/dashboard/conteudo/financeiro/contas/conta')
        },
        {
          meta: {
            child_names: ['Contas'],
            child_menus: ['Financeiro']
          },
          path: 'conciliacao/:id',
          name: 'Conciliacao',
          component: () => import(/* webpackChunkName: "n-109" */ '@Views/dashboard/conteudo/financeiro/contas/conciliacao')
        },
        {
          meta: {
            child_names: ['Receitas e Despesas'],
            child_menus: ['Financeiro']
          },
          path: 'receitas_despesas',
          name: 'ReceitasDespesas',
          component: () => import(/* webpackChunkName: "n-110" */ '@Views/dashboard/conteudo/financeiro/ReceitasDespesas/')
        },
        {
          meta: {
            child_names: ['Faturamento XML'],
            child_menus: ['Comercial']
          },
          path: 'importar_xml',
          name: 'ImportarXML',
          component: () => import(/* webpackChunkName: "n-111" */ '@Views/dashboard/conteudo/financeiro/importarXML/')
        },
        {
          meta: {
            child_names: ['Boletos'],
            child_menus: ['Financeiro']
          },
          path: 'boletos',
          name: 'Boletos',
          component: () => import(/* webpackChunkName: "n-112" */ '@Views/dashboard/conteudo/financeiro/boletos'),
          module: 'api_boleto'
        },
        {
          meta: {
            child_names: ['Pagamentos'],
            child_menus: ['Financeiro']
          },
          path: 'pagamentos',
          name: 'Pagamentos',
          component: () => import(/* webpackChunkName: "n-113" */ '@Views/dashboard/conteudo/financeiro/pagamentos'),
          module: 'api_boleto'
        },
        {
          meta: {
            child_names: ['Pagamentos'],
            child_menus: ['Financeiro']
          },
          path: 'pagamentos/contas',
          name: 'ContasPagamento',
          component: () => import(/* webpackChunkName: "n-114" */ '@Views/dashboard/conteudo/financeiro/contasPagamentos')
        },
        {
          meta: {
            child_names: ['Boletos'],
            child_menus: ['Financeiro']
          },
          path: 'boletos/contas',
          name: 'ContasBoletos',
          component: () => import(/* webpackChunkName: "n-115" */ '@Views/dashboard/conteudo/financeiro/contasBoletos')
        },
        {
          meta: {
            child_names: ['Boletos'],
            child_menus: ['Financeiro']
          },
          path: 'boletos/contas/:id',
          name: 'ConvenioBanco',
          component: () => import(/* webpackChunkName: "n-116" */ '@Views/dashboard/conteudo/financeiro/contasBoletos/convenios')
        }
      ]
    },
    {
      path: '/gestao-pessoas',
      name: 'gestao-pessoas',
      component: () => import(/* webpackChunkName: "n-117" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Gestão de Pessoas',
        roles: [
          'personalizada',
          'administrador',
          'gerente'
        ]
      },
      children: [
        {
          meta: {
            child_names: ['Folha de pagamento'],
            child_menus: ['Gestão de pessoas']
          },
          path: '/gestao-pessoas/folhas-pagamento',
          name: 'FolhasPagamento',
          component: () => import(/* webpackChunkName: "n-118" */ '@Views/dashboard/conteudo/gestao-pessoas/folhas-pagamento/')
        }
      ]
    },
    {
      path: '/relatorios',
      name: 'relatorios',
      component: () => import(/* webpackChunkName: "n-119" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Relatórios',
        roles: [
          'personalizada',
          'administrador'
        ]
      },
      children: [
        {
          meta: {
            child_names: ['Dashboard'],
            child_menus: ['Relatórios']
          },
          path: 'dashboardRelaorio',
          name: 'DashboardRelatorio',
          component: () => import(/* webpackChunkName: "n-120" */ '@Views/dashboard/conteudo/relatorios/dashboard')
        },
        {
          meta: {
            child_names: ['Fluxo de caixa diário'],
            child_menus: ['Relatórios']
          },
          path: 'fluxo_de_caixa_diario',
          name: 'FluxoDeCaixa',
          component: () => import(/* webpackChunkName: "n-121" */ '@Views/dashboard/conteudo/relatorios/fluxo_de_caixa')
        },
        {
          meta: {
            child_names: ['Fluxo de caixa mensal'],
            child_menus: ['Relatórios']
          },
          path: 'fluxo_de_caixa_mensal',
          name: 'FluxoDeCaixaMensal',
          component: () => import(/* webpackChunkName: "n-122" */ '@Views/dashboard/conteudo/relatorios/fluxo_de_caixa_mensal')
        },
        {
          meta: {
            child_names: ['Vendas por cliente'],
            child_menus: ['Relatórios']
          },
          path: 'relatorio_vendas_por_cliente',
          name: 'VendasPorCliente',
          component: () => import(/* webpackChunkName: "n-123" */ '@Views/dashboard/conteudo/relatorios/vendas_por_cliente')
        },
        {
          meta: {
            child_names: ['Compras por fornecedor'],
            child_menus: ['Relatórios']
          },
          path: 'relatorio_compras_por_fornecedor',
          name: 'ComprasPorFornecedor',
          component: () => import(/* webpackChunkName: "n-124" */ '@Views/dashboard/conteudo/relatorios/compras_por_fornecedor')
        },
        {
          meta: {
            child_names: ['Lançamentos caixa'],
            child_menus: ['Relatórios']
          },
          path: '/relatorios/relatorio_lancamentos_caixa',
          name: 'LancamentoCaixa',
          component: () => import(/* webpackChunkName: "n-125" */ '@Views/dashboard/conteudo/relatorios/lancamento_caixa')
        },
        {
          meta: {
            child_names: ['DRE Gerencial'],
            child_menus: ['Relatórios']
          },
          path: 'dre_gerencial',
          name: 'DreGerencial',
          component: () => import(/* webpackChunkName: "n-126" */ '@Views/dashboard/conteudo/relatorios/dre_gerencial')
        }
      ]
    },
    {
      path: '/',
      name: 'Developer',
      component: () => import(/* webpackChunkName: "n-127" */ '@Views/dashboard/esqueleto'),
      meta: {
        auth: true,
        name_permission: 'Principal',
        roles: [
          // 'personalizada',
          'administrador',
          'gerente'
        ]
      },
      children: [
        {
          path: 'json/profissionais',
          name: 'Developer',
          component: () => import(/* webpackChunkName: "n-128" */ '@Views/dashboard/conteudo/developer')
        },
        {
          path: 'json/pacientes',
          name: 'DeveloperPacientes',
          component: () => import(/* webpackChunkName: "n-129" */ '@Views/dashboard/conteudo/developer/pacientes')
        },
        {
          path: 'json/fornecedores-clientes',
          name: 'DeveloperFornecedoresClientes',
          component: () => import(/* webpackChunkName: "n-130" */ '@Views/dashboard/conteudo/developer/fornecedores-clientes')
        },
        {
          path: 'json/brasindice',
          name: 'DeveloperBrasindice',
          component: () => import(/* webpackChunkName: "n-131" */ '@Views/dashboard/conteudo/developer/brasindice')
        },
        {
          path: 'json/simpro',
          name: 'DeveloperSimpro',
          component: () => import(/* webpackChunkName: "n-132" */ '@Views/dashboard/conteudo/developer/simpro')
        },
        {
          path: 'json/cmed',
          name: 'DeveloperCMed',
          component: () => import(/* webpackChunkName: "n-133" */ '@Views/dashboard/conteudo/developer/cmed')
        }
      ]
    },
    {
      path: '/formulario-link/:link_token',
      name: 'FormularioLink',
      component: FormularioLink,
      meta: {
        auth: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        auth: false
      }
    }
  ]
});


// ÚLTIMO ADICIONADO: webpackChunkName: n-135
// ////////////////////////////////////////////////////////////////////////////////

const onlyModuloFinanceiroNames = [
  'FolhaPagamentoEmpresa',
  'FolhasPagamento',
  'FolhasPagamentoProfissional'
];

const checkModules = (to, next, arraySome, moduleName) => {
  if (
    arraySome.some(elem => elem === to.name)
    && !functions.hasAdditional(moduleName)
  ) {
    store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Você não tem permissão para acessar esse recurso' });
    functions.Logout()
      .then(() => {
        next('/login');
      });
  }
};

const checkAllModules = (to, next) => {
  checkModules(to, next, onlyModuloFinanceiroNames, 'modulo_financeiro');
};

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth))
    if (localStorage.getItem(TOKEN)) {
      if (store.getters.contexto)
        if (to.matched.some(record => record.meta.roles && record.meta.roles.includes(store.getters.contexto.configuracoes.permissao))) {
          const routeMeta = to.matched.find(record => record.meta);
          const child_names = (routeMeta.meta || {}).child_names || to.meta.child_names || null;
          const child_menus = (routeMeta.meta || {}).child_menus || to.meta.child_menus || [];
          if (store.getters.contexto.configuracoes.permissao_usuario && store.getters.contexto.configuracoes.permissao !== 'funcionario')
            if (
              to.matched.some(record => record.meta.name_permission && store.getters.contexto.configuracoes.permissao_usuario.some(permission => permission.id === record.meta.name_permission && permission.ativo))
              && (!child_names || (child_names && functions.hasActivePermissionUser(child_names, true, child_menus)))
            ) {
              checkAllModules(to, next);
              next();
            } else {
              store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Você não tem permissão para acessar esse recurso' });
              functions.Logout()
                .then(() => {
                  next('/login');
                });
            }
          else
          if ((!child_names || (child_names && functions.hasActivePermissionUser(child_names, true, child_menus)))) {
            checkAllModules(to, next);
            next();
          } else {
            store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Você não tem permissão para acessar esse recurso' });
            functions.Logout()
              .then(() => {
                next('/login');
              });
          }
        } else {
          store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Você não tem permissão para acessar esse recurso' });
          functions.Logout()
            .then(() => {
              next('/login');
            });
        }
      else
        UsuarioPresenter.getContexto()
          .then(response => {
            store.dispatch('CONTEXTO', response);
            if (to.matched.some(record => record.meta.roles && record.meta.roles.includes(response.configuracoes.permissao))) {
              const routeMeta = to.matched.find(record => record.meta);
              const child_names = (routeMeta.meta || {}).child_names || to.meta.child_names || null;
              const child_menus = (routeMeta.meta || {}).child_menus || to.meta.child_menus || [];
              if (response.configuracoes.permissao_usuario)
                if (
                  to.matched.some(record => record.meta.name_permission && response.configuracoes.permissao_usuario.some(permission => permission.id === record.meta.name_permission && permission.ativo))
                  && (!child_names || (child_names && functions.hasActivePermissionUser(child_names, true, child_menus)))
                ) {
                  checkAllModules(to, next);
                  next();
                } else {
                  store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Você não tem permissão para acessar esse recurso' });
                  functions.Logout()
                    .then(() => {
                      next('/login');
                    });
                }
              else
              if ((!child_names || (child_names && functions.hasActivePermissionUser(child_names, true, child_menus)))) {
                checkAllModules(to, next);
                next();
              } else {
                store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Você não tem permissão para acessar esse recurso' });
                functions.Logout()
                  .then(() => {
                    next('/login');
                  });
              }
            } else {
              store.dispatch('SHOW_SNACKBAR', { color: 'error', message: 'Você não tem permissão para acessar esse recurso' });
              functions.Logout()
                .then(() => {
                  next('/login');
                });
            }
          });
    } else
      functions.Logout()
        .then(() => {
          next('/login');
        });
  else
    next();
});

export default router;
